import React from 'react'
import Call from './Call'
import { useMediaQuery, useTheme } from '@mui/material'

const DownloadApp = () => {
    const theme = useTheme()
    const phone = useMediaQuery(theme.breakpoints.between(280,830))
  return (
    <>
        <Call phone={phone} />
    </>
  )
}

export default DownloadApp